import React, { useState, useEffect } from "react";
import axios from "axios";
import { Input, Stack, Box, Typography, useTheme, Button, styled, } from "@mui/material";
import {Badge, theme} from "@material-ui/core";
import Select from "react-select";
import urls from './../../constants/urls';



const TXTRoundedDiv= styled("div")(({theme})=>({
    borderRadius: theme.shape.borderRadius,
    border: "1px solid #6BD5C0",
    //border: "#65BDC0",
    width: "100%",
    //height: "100%",
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "10px",

}));

const StyledBox= styled(Box)({
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "5px",
});

const StyledInput= styled(Input)({
  fontSize: "14px",
  width: "100%",
  height: "95%",
  marginTop: "2px",
  marginBottom: "2px"

});

const StyledSelect= styled(Select)({
    fontSize: "14px",
  width: "100%",
  height: "95%",
  marginTop: "2px",
  marginBottom: "2px"
});



export default function SchoolUpdate( { schoolId, schoolName, wardId, districtId, cityId, wardName, districtName, cityName, schoolCode, street, plotNumber, areaDetails, telephoneNumber1, telephoneNumber2, email, website  } ) {
  
  const [APIROOTURL, setAPIROOTURL]=useState(urls.rootAPIURL);

  const [ formData, setFormData]= useState({
            ward: 1,
            name: schoolName,
            status: schoolId,
            school_code: schoolCode,
            street: street,
            plot_number: plotNumber,
            area_details: areaDetails,
            telephone_number_1: telephoneNumber1,
            telephone_number_2: telephoneNumber2,
            email: website,
            website: website,
      })
  
  const [cities, setCities]=useState([]);
  const [city, setCity]=useState('Select city');
  
  const [districts, setDistricts]=useState([]);
  const [districtsOG, setDistrictsOG]=useState([]);
  const [district, setDistrict]=useState('');
  
  const [wards, setWards]=useState([]);
  const [wardsOG, setWardsOG]=useState([]);
  const [ward, setWard]=useState('');
  
  
  
  const [errors, setErrors]=useState({});

  
  

  const customStyles = {
        option: (base, { data, isDisabled, isFocused, isSelected }) => {
        return {
        ...base,
        backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
        };
    }
    };

  const reloadDistricts=(cityId)=>{
   let newList=[]
    newList=districtsOG.filter(districtsOG=>districtsOG.city_id===cityId);
    setDistricts(newList);
  }
  
  const reloadWards=(districtId)=>{
    let newList=[]
     newList=wardsOG.filter(wardsOG=>wardsOG.district_id===districtId);
     setWards(newList);
    
   }

  const handleChangeSelect = (e) =>{
    const {name, value } = e

    //console.log("e.target.name=" + e.target.name)
    console.log("name=" + name +  ", value=" + value)
    
    if(name==="ward"){
        setFormData({
        ...formData,
        [ward]: e.id
        })
   }
    //
    if(name==="city"){
        console.log("city=" + city);
        console.log("city e.id=" + e.id);
        
        setCity(e.value);
        reloadDistricts(e.id)
    }
    
    if(name==="district"){
        setDistrict(e.value);
        reloadWards(e.id);
    }
    
    if(name==="ward"){
      setFormData({
        ...formData,
        [name]: 1
        })
        setWard(1);
    }

   //
   setErrors({});
    //
  }
 
 const handleChangeInput = (e) =>{
   const {name, value } =e.target
   setFormData({
    ...formData,
    [name]: value
   })
   //
   
   //
   setErrors({});
 }

  const loadCities=(data)=>{
    let newList=[]
    newList.push({ id: 0, label: 'Select city', value: 'Select city', name: 'city'})
    {
        data.map(function(dt){
          newList.push({id: dt.id, label: dt.name, value: dt.name , name: 'city'})
        })
    }

    setCities(newList)
  }

  
  const loadDistricts=(data)=>{
    let newList=[]
    newList.push({ name: 'district', id: 0, label: 'Select district', value: 'Select district' , city_id: 0})
    {   
        data.map(function(dt){
          newList.push({name: 'district', id: dt.id, label: dt.name, value: dt.name, city_id: dt.city_id})
        })
    }
    
    setDistricts(newList)
    setDistrictsOG(newList)
  }


  
  const loadWards=(data)=>{
    let newList=[]
    newList.push({ name: 'ward', id: 0, label: 'Select ward', value: 'Select ward', district_id: 0})
    {   
        data.map(function(dt){
          newList.push({ name: 'ward', id: dt.id, label: dt.name, value: dt.name , district_id: dt.district_id})
        })
    }
    
    setWards(newList)
    setWardsOG(newList)
  }
   

  const handleButtonUpdate = () =>{
    
   console.log("formData.name=" + formData['name'])

    let newErrors=validateForm(formData);
    setErrors(newErrors);
    
    console.log("errors.lenght=" + Object.keys(newErrors).length)
    if(Object.keys(newErrors).length===0){
      console.log("len0")
      UpdateSchool()
    }
    else{
      console.log("len1")
    }
    /***
    
    ***/

}


    
const validateForm = (data) =>{
  const errors={};
  let regExp=/^[a-zA-Z0-9._]+@[a-z]+\.[a-z]{2-6}$/;
  
  let regExpPassword=/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,10})/
  
  console.log("data=" + data)
  console.log("data.name=" + data.name)
  
  console.log("district=" + district)
  //if(!(data.service_category.toString()).trim()){
  if(data.name==="" || data.name==""){
    console.log("if " + ", data.name=" + data.name)
    errors.name='Please enter school name';
   }
   else{
    console.log("else " + ", data.name=" + data.name)
   }

  if(city==="Select city" || city=="Select city" || city=="" ){
    errors.city='Please select city';
  }

  if(district==="Select district" || district=="Select district" || district==""){
    errors.district='Please select district';
  }

  if(ward==="Select ward" || ward=="Select ward" || ward==""){
    errors.ward='Please select ward';
  }
  
  if(!(data.ward.toString()).trim()){
    errors.ward='Please select ward';
   }

   

   if(!(data.street.toString()).trim()){
    errors.street='Please enter street';
   }

   if(!(data.plot_number.toString()).trim()){
    errors.plot_number='Please enter plot number';
   }

   if(!(data.area_details.toString()).trim()){
    errors.area_details='Please enter area details';
   }

   if(!(data.telephone_number_1.toString()).trim()){
    errors.telephone_number_1='Please enter primary telephone 1';
   }

   if(!(data.telephone_number_2.toString()).trim()){
    errors.telephone_number_2='Please enter secondary telephone 2';
   }

   if(!(data.website.toString()).trim()){
    errors.website='Please enter website';
   }

  if(!(data.email.toString()).trim()){
     errors.email='Please enter email';
 }
 ///     (!/\S+@\S+\.\S+/.test(data.email)
 ///       /.+@.+\.[A-Za-z]+$/
 ///       /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/
 ///       /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/
 ///       /^[a-zA-Z0-9._]+@[a-z]+\.[a-z]{2-6}$/
 /***
  if (!regExp.test(data.email)) {
     errors.email = 'Email is invalid';
    }
 ***/
 /*** *
 
 
 ***/
  return errors;
}

   
  
    useEffect(()=>{
      
    let APIURL= APIROOTURL + "CitiesViewEXT"
    let headerOptions={
        method: 'GET',
    }

    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json =>{
     console.log("json=" + json);
     loadCities(json)
    })
    .catch(error=> console.log("error=" + error))
    
    },[])



    useEffect(()=>{
      
        let APIURL= APIROOTURL + "DistrictsViewEXT"
        let headerOptions={
            method: 'GET',
        }
    
        fetch(APIURL, headerOptions)
        .then( response => response.json())
        .then( json =>{
         console.log("json=" + json);
         loadDistricts(json)
        })
        .catch(error=> console.log("error=" + error))
        
        },[])

    
        
    useEffect(()=>{
      
        let APIURL= APIROOTURL + "WardsViewEXT"
        let headerOptions={
            method: 'GET',
        }
    
        fetch(APIURL, headerOptions)
        .then( response => response.json())
        .then( json =>{
         console.log("json=" + json);
         loadWards(json)
        })
        .catch(error=> console.log("error=" + error))
        
        },[])
  

   const UpdateSchool=()=>{
     
     
    //let url = API_URL;
    let APIURL= APIROOTURL + "UpdateSchoolsViewEXT"
    let picsId=0;
    axios
      .post(APIURL, formData, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("res.data=" + res.data);
        console.log("res.data=" + res.data.msg);
        alert( res.data.msg);
        //console.log("res.data['id']=" + res.data['id']);
        //picsId=res.data['id'];

      })
      .finally(() => {
       
    
      })
      .catch((err) => console.log(err));


   }   
   
   
  return (

    <Stack direction="row" spacing={1}>
     <Box flex={3}>
     </Box>
     <Box flex={6}>
            <Typography
              variant="h4"
              
              sx={{ m: "15px 0 5px 20px" }}
            >
              UPDATE SCHOOL DETAILS @ {schoolName}
            </Typography>

            <br/>
        {/***
        <TXTRoundedDiv>
           <StyledInput
            name="name"
            placeholder="School name"
            onChange={handleChangeInput}
           />
           { errors.name && (<span> errors.name </span>)}
         </TXTRoundedDiv>
         ***/}
         
         <TXTRoundedDiv>
              <Select
                  name="city"
                  placeholder="Select city"
                  options={cities}
                  styles={customStyles}
                  onChange={handleChangeSelect}
              />
              {errors.city && (<span> {errors.city} </span>)}
         </TXTRoundedDiv>


         <TXTRoundedDiv>
              <Select
                  name="district"
                  placeholder="Select district"
                  options={districts}
                  
                  styles={customStyles}
                  /*
                  */
                  onChange={handleChangeSelect}
                  //value={district}
              />
              {errors.district && (<span> {errors.district} </span>)}
         </TXTRoundedDiv>
         
         {/*** *
         <TXTRoundedDiv>
              <Select
                  name="ward"
                  placeholder="Select ward"
                  options={wards}
                  
                  styles={customStyles}
                  
                  onChange={handleChangeSelect}
                  
              />
              {errors.ward && (<span> {errors.ward} </span>)}
         </TXTRoundedDiv>
           ***/}

         <TXTRoundedDiv>
           <StyledInput
            name="name"
            value={formData['name']}
            placeholder="School name"
            onChange={handleChangeInput}

           />
           { errors.name && (<span> {errors.name} </span>)}
         </TXTRoundedDiv>

         <TXTRoundedDiv>
           <StyledInput
            name="street"
            value={formData['street']}
            placeholder="Street"
            onChange={handleChangeInput}

           />
           { errors.street && (<span> {errors.street} </span>)}
         </TXTRoundedDiv>
        

         <TXTRoundedDiv>
           <StyledInput
            name="plot_number"
            value={formData['plot_number']}
            placeholder="Plot Number"
            onChange={handleChangeInput}
            
           />
           { errors.street && (<span> {errors.street} </span>)}
         </TXTRoundedDiv>

         <TXTRoundedDiv>
           <StyledInput
            name="area_details"
            placeholder="Area details"
            value={formData['area_details']}
            onChange={handleChangeInput}
            
           />
           { errors.area_details && (<span> {errors.area_details} </span>)}
         </TXTRoundedDiv>

         <TXTRoundedDiv>
           <StyledInput
            name="telephone_number_1"
            placeholder="Primary Telephone No"
            value={formData['telephone_number_1']}
            onChange={handleChangeInput}
            
           />
           { errors.telephone_number_1 && (<span> {errors.telephone_number_1} </span>)}
         </TXTRoundedDiv>
         
         <TXTRoundedDiv>
           <StyledInput
            name="telephone_number_2"
            placeholder="Secondary Telephone No"
            value={formData['telephone_number_2']}
            onChange={handleChangeInput}
            
           />
           { errors.telephone_number_2 && (<span> {errors.telephone_number_2} </span>)}
         </TXTRoundedDiv>
        
         <TXTRoundedDiv>
           <StyledInput
            name="email"
            placeholder="Email"
            value={formData['email']}
            onChange={handleChangeInput}
            
           />
           { errors.email && (<span> {errors.email} </span>)}
         </TXTRoundedDiv>
        
         <TXTRoundedDiv>
           <StyledInput
            name="website"
            placeholder="Website"
            value={formData['website']}
            onChange={handleChangeInput}
            
           />
           { errors.website && (<span> {errors.website} </span>)}
         </TXTRoundedDiv>
      {/*** 
       * 
        id = models.BigAutoField(primary_key=True)
        ward=models.ForeignKey(district, on_delete=models.CASCADE)
    status=models.CharField(max_length=32)
    name=models.CharField(max_length=128)
    school_code=models.CharField(max_length=16, default="")
    street=models.CharField(max_length=32)
    plot_number=models.CharField(max_length=32)
    area_details=models.CharField(max_length=128)
    telephone_number_1=models.CharField(max_length=16)
    telephone_number_2=models.CharField(max_length=16)
    email=models.CharField(max_length=128)
    website=models.CharField(max_length=128)
       * ***/}

      <Button type="Submit"  color="secondary" variant="contained" onClick={handleButtonUpdate}>
       UPDATE
      </Button>

     </Box>
     <Box flex={3}>
     </Box>
    </Stack>
  )
}
